<template>
  <div
    class="container-fluid"
    v-if="auth == 'loggedin' || token != null || token != undefined"
  >

    <!-- // MAINFORM -->
    <b-form id="main">

      <div class="row col-sm-12 mt-2">

          <!-- // MAIN DATAS -->

          <div class="col-sm-2">
            <div class="form-group" hidden>
              <label for="azon">Azonosító</label>
              <b-form-input
                size="sm"
                type="text"
                v-model="azonTemp"
                class="form-control"
                id="azon"
                disabled
              />
            </div>
              <label for="partner">Státusz</label>
              <b-form-select
                label="Státusz"
                v-model="statusSelect"
                :options="status"
                @change="statusChange"
                size="sm"
                id="status"
              ></b-form-select>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label for="kategoria">Partner kat.</label>
              <b-form-select
                size="sm"
                v-if="$route.params.id"
                v-model="partnerkategoriaSelected"
                @change="categoryChange"
                :options="partnerkategoria"
                class="form-control"
                id="kategoria"
                required
                disabled
              ></b-form-select>
              <b-form-select
                size="sm"
                v-if="!$route.params.id"
                v-model="partnerkategoriaSelected"
                @change="categoryChange"
                :options="partnerkategoria"
                class="form-control"
                id="kategoria"
                required
              ></b-form-select>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group" >
              <label for="partner">MiniCRM adatlap neve</label>
              <b-form-input ref="MiniCRM" size="sm" v-model="partner" id="partner" required></b-form-input>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label for="emaillink">MiniCRM adatlap link</label>
              <b-form-input size="sm" v-model="emaillink" id="emaillink" required></b-form-input>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="megjegyzes">Megjegyzés</label>
              <textarea v-model="megjegyzes" class="form-control" id="megjegyzes" cols="30" rows="1"></textarea>
            </div>
          </div>
      </div>

    </b-form>

    <!-- // EDITOR SECTION -->
    <div class="row">



      <!-- // NYOMDAI MUNKALAP EDITOR -->
      <div v-show="nyomdaiMunkalapPanelShow" class="col-sm-12 mx-auto" style="bottom: 20px;">
        <b-card
          header="Nyomdai munkalap tételek"
          border-variant="secondary"
          header-bg-variant="secondary"
          header-text-variant="white"
          class="text-center mt-2"
        >
          <!-- <form @submit.stop.prevent="onSubmit"> -->
            <div class="row col-sm-12 mx-auto">
              <form @submit.stop.prevent="savePage">
                <table class="table fluid">
                  <thead>
                    <tr>
                      <th class="text-left">Megnevezés</th>
                      <th>Méret</th>
                      <th>Terjedelem</th>
                      <th>Papír</th>
                      <th>Szín</th>
                      <th>Kötészet</th>
                      <th>Opció</th>
                      <th>Egyéb</th>
                      <th>Mennyiség</th>
                      <th>Darabár</th>
                      <th>Összesen</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.megnevezes" id="megnevezes" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.meret" id="meret" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.terjedelem" id="terjedelem" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.papir" id="papir" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.szin" id="szin" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.koteszet" id="koteszet" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.opciok" id="opciok" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.egyeb" id="egyeb" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.menyiseg" id="menyiseg" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.darabar" id="darabar" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.osszesen" id="osszesen" required >
                      </td>
                      <td hidden style="width: 400px;">
                        <select v-model="anyagTipusSelect" class="form-control" id="anyagtipus" >
                          <option v-for="(anyagtipus) in anyagTipus" :key="anyagtipus.id" :value="anyagtipus">
                            {{ anyagtipus.tipus }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <button @click="addElement($event)" class="btn btn-primary mb-2">
                          <b-icon-plus-circle></b-icon-plus-circle>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div hidden>
                    <label for="anyagT">Anyag+kivitel</label>
                    <input type="text" class="form-control" v-model="anyagTipusSelect.tipus" id="anyagT" required>
                </div>
              </form>
            </div>

              <div class="row">

                <!-- // PAGE DETAILS ADD -->
                <div class="col-sm-12 mx-auto">
                  <table class="table mx-auto">
                    <tbody>
                    <tr v-for="(element, index) in myTetels" :key="element.id">
                      <td class="text-left" hidden>{{anyagTipusSelect.tipus}}</td>
                      <td>{{element.tetelnev}}</td>
                      <td>{{element.db}}</td>
                      <td>{{parseFloat(element.cm1, 1).toFixed(1)}}</td>
                      <td>{{parseFloat(element.cm2, 1).toFixed(1)}}</td>
                      <td class="text-right">{{parseFloat(element.m2, 2).toFixed(2)}}</td>
                      <td>
                        <b-button
                          size="sm"
                          variant="outline-danger"
                          @click="deleteTetel(myTetels, index)"
                          class="mr-1"
                        ><b-icon-trash></b-icon-trash>
                        </b-button>
                      </td>
                    </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colspan="3">Összeterület: </th>
                        <th class="text-right" colspan="2">{{parseFloat(osszterulet, 2).toFixed(2)}}</th>
                      </tr>
                    </tfoot>
                  </table>

                  <!-- SAVE CARD -->
                  <b-button @click="savePage" type="submit" class="btn btn-info mb-2 float-left">
                    <b-icon-cloud-upload></b-icon-cloud-upload>
                    Tétel összesítő mentése
                  </b-button>

                  <!-- CANCEL CARD -->
                  <b-button
                    variant="outline-danger"
                    class="float-right"
                    @click="nyomdaiMunkalapPanelShow=false, MunkalapShow=true"
                    ><b-icon-arrow-left></b-icon-arrow-left>
                    Mégsem
                  </b-button>
                </div>

              </div>

        </b-card>
      </div>






      <!-- // PAGE EDITOR -->
      <div v-show="AnyagPanelShow" class="col-sm-9 mx-auto" style="bottom: 20px;">
        <b-card
          header="Munkalap tételek"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
          class="text-center mt-2"
        >
          <!-- <form @submit.stop.prevent="onSubmit"> -->
            <div class="row col-sm-12 mx-auto">
              <form @submit.stop.prevent="savePage">
                <table class="table fluid">
                  <thead>
                    <tr>
                      <th class="text-left">Azonosító (fájlnév)</th>
                      <th>Darab</th>
                      <th>Szélesség (x) cm</th>
                      <th>Magasság (y) cm</th>
                      <th class="text-left">
                        Anyag+kivitel
                        <!-- LEIRÁS MODÁL -->
                        <b-button size="sm" v-show="AnygaleirasShow" variant="outline-warning" class="float-right mb-2" v-b-modal.modal-3><b-icon-chat-text class="mr-1"></b-icon-chat-text>Anyag+kivitel súgó</b-button>
                        <b-modal id="modal-3" size="lg" title="Leírás">
                          <h3>{{anyagTipusSelect.tipus}}</h3>
                          <p class="my-4">{{anyagTipusSelect.megnevezes}}</p>
                          <p class="my-4">{{anyagTipusSelect.leiras}}</p>
                          <template #modal-footer="{ ok, cancel, hide }">
                            <b-button size="sm" variant="outline-danger" @click="cancel()">
                              Bezárás
                            </b-button>
                          </template>
                        </b-modal>
                      </th>
                      <th>Tétel hozzáadás</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="width: 400px;">
                        <input type="text" class="form-control" v-model="myTempElements.tetelnev" id="tetelnev" required >
                      </td>
                      <td style="width: 150px;">
                        <input type="number" class="form-control" v-model="myTempElements.db" id="db" required >
                      </td>
                      <td>
                        <input type="number" class="form-control" v-model="myTempElements.cm1" id="cm1" required >
                      </td>
                      <td>
                        <input type="number" class="form-control" v-model="myTempElements.cm2" id="cm2" required >
                      </td>
                      <td style="width: 400px;">
                        <select v-model="anyagTipusSelect" class="form-control" id="anyagtipus" >
                          <option v-for="(anyagtipus) in anyagTipus" :key="anyagtipus.id" :value="anyagtipus">
                            {{ anyagtipus.tipus }}
                          </option>
                        </select>
                        <select v-model="megmunkalasSelect" class="form-control mt-1" id="anyagmegmunkalas" style="border-color: #dc3545; color: #dc3545;">
                          <option :value="null">— nincs megmunkálás —</option>
                          <option v-for="(megmunkalas) in visibleMegmunkalasList" :key="megmunkalas.id" :value="megmunkalas">
                            {{ megmunkalas.megnevezes }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <button @click="addElement($event)" class="btn btn-primary mb-2">
                          <b-icon-plus-circle></b-icon-plus-circle>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div hidden>
                    <label for="anyagT">Anyag+kivitel</label>
                    <input type="text" class="form-control" v-model="anyagTipusSelect.tipus" id="anyagT" required>
                </div>
              </form>
            </div>

              <div class="row">

                <!-- // PAGE DETAILS ADD -->
                <div class="col-sm-12 mx-auto">
                  <table class="table mx-auto">
                    <thead>
                      <tr>
                        <th hidden class="tableformat">Anyag</th>
                        <th class="tableformat text-left">Azonosító (fájlnév)</th>
                        <th class="tableformat">Darab</th>
                        <th class="tableformat">Szélesség (x) cm</th>
                        <th class="tableformat">Magasság (y) cm</th>
                        <th class="tableformat text-right" style="width:70px;">m2</th>
                        <th class="tableformat text-right" style="width:70px;">fm</th>
                        <th style="width:50px;">X</th>
                      </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(element, index) in myTetels" :key="element.id">
                      <td class="text-left" hidden>{{anyagTipusSelect.tipus}}</td>
                      <td>{{element.tetelnev}}</td>
                      <td>{{element.db}}</td>
                      <td>{{parseFloat(element.cm1, 1).toFixed(1)}}</td>
                      <td>{{parseFloat(element.cm2, 1).toFixed(1)}}</td>
                      <td class="text-right" style="width:70px;">{{parseFloat(element.m2, 2).toFixed(2)}}</td>
                      <td class="text-right" style="width:70px;">{{parseFloat(element.fm || 0, 2).toFixed(2)}}</td>
                      <td>
                        <b-button
                          size="sm"
                          variant="outline-danger"
                          @click="deleteTetel(myTetels, index)"
                          class="mr-1"
                        ><b-icon-trash></b-icon-trash>
                        </b-button>
                      </td>
                    </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th hidden></th>
                        <th colspan="4" class="text-right">Összterület:</th>
                        <th class="text-right" style="width:70px;">{{parseFloat(osszterulet, 2).toFixed(2)}}</th>
                        <th class="text-right" style="width:70px;">{{parseFloat(osszfm, 2).toFixed(2)}}</th>
                        <th style="width:50px;"></th>
                      </tr>
                      <tr v-if="megmunkalasSelect && megmunkalasSelect.id">
                        <th hidden></th>
                        <th colspan="6" style="color: #dc3545;">Megmunkálás típusa: ({{megmunkalasSelect.megnevezes}})</th>
                        <th></th>
                      </tr>
                    </tfoot>
                  </table>

                  <!-- SAVE CARD -->
                  <b-button @click="savePage" type="submit" class="btn btn-info mb-2 float-left">
                    <b-icon-cloud-upload></b-icon-cloud-upload>
                    Tétel összesítő mentése
                  </b-button>

                  <!-- CANCEL CARD -->
                  <b-button
                    variant="outline-danger"
                    class="float-right"
                    @click="AnyagPanelShow=false, MunkalapShow=true"
                    ><b-icon-arrow-left></b-icon-arrow-left>
                    Mégsem
                  </b-button>
                </div>

              </div>

        </b-card>
      </div>


      <!-- // ÚJ MUNKALAP -->
      <div v-show="MunkalapShow" class="col-sm-12 mt-3 mx-auto" style="bottom: 20px;">
        <b-card
          header
          border-variant="secondary"
          header-bg-variant="none"
          header-text-variant="white"
          header-border-variant="none"
          footer
          header-class="munkalapcardheader"
        >
          <template#header>
            <em>
              <table style="width:960px;" class="center">
                <tbody>
                  <tr>
                    <td>
                      <b-button
                        size="sm"
                        variant="primary"
                        class="float-left"
                        type="submit"
                        @click="mainDataButtonClick"
                        ><b-icon-plus-circle></b-icon-plus-circle>
                        Anyag + kivitel
                      </b-button>
                    </td>
                    <td>
                      <b-button
                        size="sm"
                        variant="outline-warning"
                        class="float-left"
                        v-b-modal.modal-1
                      ><b-icon-plus-circle></b-icon-plus-circle>
                      Egyéb tételek</b-button>
                    </td>
                    <!-- <td>
                      <b-button
                        size="sm"
                        variant="secondary"
                        class="float-left"
                        type="submit"
                        @click="nyomdaiMunkalapPanel"
                        ><b-icon-plus-circle></b-icon-plus-circle>
                        Nyomdai munkalap tétel
                      </b-button>
                    </td> -->
                    <td>
                      <!-- // SAVE -->
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        class="float-right mr-2"
                        type="button"
                        @click="exportCurrentToCsv"
                      >
                        <b-icon-download></b-icon-download>
                        CSV export
                      </b-button>
                      <b-button
                        size="sm"
                        variant="success"
                        class="float-right"
                        type="submit"
                        @click="saveWork"
                        ><b-icon-cloud-upload></b-icon-cloud-upload>
                        Munkalap mentése
                      </b-button>
                    </td>
                    <td>
                      <!-- // CANCEL -->
                      <!-- <b-button
                        size="sm"
                        variant="outline-danger"
                        class="float-right"
                        @click="
                          $router.push({
                            name: 'Munkak'
                          })
                        "
                        ><b-icon-arrow-left></b-icon-arrow-left>
                          Mégsem
                        </b-button>
                       -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </em>
          </template>

          <!-- MUNKALAP TABÁLÁZAT -->
          <div class="col-sm-12">
            <div class="row" v-for="(pageElement, index) in myTempAnyagTipus" :key="pageElement.id">
              <div class="col-md-12 mx-auto" hidden>
                <p>Anyag típus: {{pageElement.tipusName}}</p>
              </div>

              <div class="col-md-12">

                <table style="width:960px !important;" class="center pagedetail table-sm mt-1 munkalap-grid">
                  <colgroup>
                    <col style="width:55px;">
                    <col style="width:280px;">
                    <col style="width:48px;">
                    <col style="width:48px;">
                    <col style="width:52px;">
                    <col style="width:52px;">
                    <col style="width:62px;">
                    <col style="width:130px;">
                    <col style="width:105px;">
                  </colgroup>
                  <tbody>
                  <tr class="bordered" v-for="(pageTetel) in pageElement.tetels" :key="pageTetel.id">
                    <th></th>
                    <th class="text-left munkalap-item-name">{{pageTetel.tetelnev}}</th>
                    <th class="text-right">{{pageTetel.db}}</th>
                    <th class="text-right">{{parseFloat(pageTetel.cm1, 1).toFixed(1)}}</th>
                    <th class="text-right">{{parseFloat(pageTetel.cm2, 1).toFixed(1)}}</th>
                    <th class="text-right">{{parseFloat(pageTetel.m2, 2).toFixed(2)}}</th>
                    <th class="text-right text-danger">{{parseFloat(pageTetel.fm || 0, 2).toFixed(2)}}</th>
                    <th></th>
                    <th class="text-right">
                      <div class="input-group input-group-sm justify-content-end munkalap-darabar-input">
                        <input
                          type="number"
                          v-model.number="pageTetel.darabar"
                          class="form-control text-right form-control-sm munkalap-price-input"
                        >
                        <div class="input-group-append">
                          <span class="input-group-text">/db</span>
                        </div>
                      </div>
                    </th>
                  </tr>
                  </tbody>
                  <tfoot>
                    <tr class="footerrow">
                      <th class="text-right labelsize1 darkgray">
                        <b-button
                          size="sm"
                          variant="outline-success"
                          class="btnmini mr-1 mb-2 float-left"
                          @click="editMaterial({page: pageElement})"
                        ><b-icon-pencil-fill></b-icon-pencil-fill>
                        </b-button>
                        <b-button
                          size="sm"
                          variant="outline-danger float-left"
                          @click="$delete(myTempAnyagTipus, index)"
                          class="btnmini ml-2"
                        ><b-icon-trash></b-icon-trash>
                        </b-button>
                      </th>
                      <th class="text-left labelsize1 darkgray" colspan="4">
                        {{pageElement.megnevezes}}
                      </th>
                      <th class="text-right">{{parseFloat(pageElement.osszterulet, 2).toFixed(2)}}</th>
                      <th></th>
                      <td class="text-right">{{pageElement.tipusName}}</td>
                      <th class="text-right">
                        <input type="number" v-on="getVegOsszeg" @keyup="onPageArChange(pageElement)" v-model="pageElement.pageAr" :key="pageElement.id" class="form-control text-right form-control-sm munkalap-price-input" id="ar" required>
                      </th>
                    </tr>
                    <tr class="footerrow" v-if="pageElement.megmunkalasid && pageElement.blockType !== 'megmunkalas'">
                      <th></th>
                      <th colspan="4"></th>
                      <th></th>
                      <th class="text-right text-danger">{{parseFloat(pageElement.osszfm || 0, 2).toFixed(2)}}</th>
                      <td class="text-right">{{pageElement.megmunkalasName}}</td>
                      <th class="text-right">
                        <input type="number" @keyup="onMegmunkalasArChange(pageElement)" v-model.number="pageElement.megmunkalas_ar" class="form-control text-right form-control-sm munkalap-price-input">
                      </th>
                    </tr>
                    <tr class="footerrow" v-if="shouldShowBlockTotalRow(pageElement)">
                      <th colspan="8"></th>
                      <th class="text-right munkalap-block-total">{{ blockPageOsszeg(pageElement) }}</th>
                    </tr>
                    <tr class="table">
                      <td colspan="9"></td>
                    </tr>
                  </tfoot>
                </table>

              </div>

            </div>

            <!-- // EGYÉB TÉTEL -->
            <div v-if="myCikkTetels " v-show="EgyebTetelekShow">
              <table style="width:960px !important;"  class="table-sm mx-auto mt-1">
                <!-- <thead class="mx-auto">
                  <tr>
                    <td>DEL</td>
                    <td class="text-left">Megnevezés</td>
                    <td>Egység</td>
                    <td>Darab</td>
                    <td class="text-right">Nettó egységár</td>
                    <td class="text-right">Nettó összesen</td>
                  </tr>
                </thead> -->
                <tbody>
                  <tr v-for="(tetel, index) in myCikkTetels" :key="tetel.id">
                    <th style="width:60px !important;" colspan="1" >
                      <b-button
                        size="sm"
                        variant="outline-danger"
                        @click="$delete(myCikkTetels, index)"
                        class="btnmini mr-1"
                      ><b-icon-trash></b-icon-trash>
                      </b-button>
                    </th>
                    <th style="width:270px !important;"  class="text-left">{{tetel.megnevezes}}</th>
                    <th style="width:50px !important;" >
                      <input type="number" v-model="tetel.db" @keyup="getVegOsszeg1" :key="tetel.id" class="form-control inputmini form-control-sm text-right" id="mennyiseg" required>
                    </th>
                    <th style="width:50px !important;" >{{tetel.mennyisegiegyseg}}</th>
                    <th style="width:50px !important;" ></th>
                    <td style="width:170px !important; font-size:smaller;"  class="text-right darkgray"></td>
                    <th style="width:170px !important; font-size:smaller;"  class="text-right">{{parseFloat(tetel.netto).toFixed(2) * parseFloat(tetel.db).toFixed(2)}}</th>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="table">
                    <td colspan="8"></td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <!-- // MODAL EGYÉB TÉTEL -->
            <div>
              <b-modal id="modal-1" title="Egyéb tételek" >
                <div class="form-group" >
                  <label for="cikkek">Egyéb tételek hozzáadása</label>
                  <select v-model="cikkSelect" class="form-control" id="cikkek">
                    <option v-for="(cikkek) in cikkek" :key="cikkek.id" :value="cikkek">
                      {{ cikkek.megnevezes }}
                    </option>
                  </select>
                </div>
                <template #modal-footer>
                  <div class="w-100">
                    <b-button
                      variant="primary"
                      size="sm"
                      class="float-right"
                      @click="addCikkTetel"
                    ><b-icon-plus-circle></b-icon-plus-circle>
                      Hozzáadás
                    </b-button>
                  </div>
                </template>
              </b-modal>
            </div>

          </div>

          <!-- // VÉGÖSSZEG -->
          <!-- <div class="col-sm-6 mx-auto">

            <div class="row">
              <div class="col-sm-4 mx-auto text-right">
                <p :prop="getVegOsszeg">Kalkulált végösszeg: </p>
              </div>
              <div class="col-sm-4 mx-auto">
                <p class="float-left">{{VegOsszeg}}</p>
              </div>
              <div class="col-sm-4 mx-auto">
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4 mx-auto text-right">
                <h3 :prop="getVegOsszeg">Végösszeg: </h3>
              </div>
              <div class="col-sm-4 mx-auto">
                <input id="vegosszeg1" class="form-control form-control-sm" type="number" v-model="VegSumOsszeg" >
              </div>
              <div class="col-sm-4 mx-auto">
                <b-button
                  size="sm"
                  variant="outline-info"
                  class="float-left"
                  type="submit"
                  @click="getVegOsszeg1"
                ><b-icon-arrow-clockwise></b-icon-arrow-clockwise>
                Újraszámolás
                </b-button>
              </div>
            </div>
          </div> -->

            <div>
              <table style="width:960px !important;" class="mx-auto">
              <!-- <table style="width:960px !important;" class=" table-bordered center mr-2"> -->
                <tbody>
                  <tr class="text-right darkgray" style=" font-size:smaller;">
                    <td  :prop="getVegOsszeg" >Számított végösszeg : </td>
                    <td style="padding-right: 10px; ">{{VegOsszeg}}</td>
                  </tr>
                  <tr class="text-right">
                    <td>
                      <h5 :prop="getVegOsszeg">Kiajánlott ár : </h5>
                    </td>
                    <td style="width:100px !important;">
                      <input style="font-weight:bold; height: calc(1em + 0.5rem + 2px);" id="vegosszeg1" class="form-control miniinput form-control-sm text-right" type="number" v-model="VegSumOsszeg" >
                    </td>
                    <!-- <td>
                      <b-button
                        size="sm"
                        variant="outline-info"
                        class="float-left"
                        type="submit"
                        @click="getVegOsszeg1"
                      ><b-icon-arrow-clockwise></b-icon-arrow-clockwise>
                      Újraszámolás
                      </b-button>
                    </td> -->
                  </tr>
                </tbody>
              </table>

            </div>

          <!-- FOOTER     -->
          <!-- <template #footer>
            <em>
              <div class="col-sm-12 mx-auto">
                <div>
                  // SAVE
                  <b-button
                  size="sm"
                    variant="success"
                    class="float-left"
                    type="submit"
                    @click="saveWork"
                    ><b-icon-cloud-upload></b-icon-cloud-upload>
                    Munkalap mentése
                  </b-button>

                  // CANCEL
                  <b-button
                  size="sm"
                    variant="outline-danger"
                    class="float-left ml-1"
                    @click="
                      $router.push({
                        name: 'Munkak'
                      })
                    "
                    ><b-icon-arrow-left></b-icon-arrow-left>
                      Mégsem
                    </b-button>

                </div>
              </div>
            </em>
          </template>               -->

        </b-card>
      </div>
    </div>


      <!-- <div class="row">
        <div class="col-sm-6 mx-auto">
          <p>erer</p>
        </div>
        <div class="col-sm-6 mx-auto">
          <p>erer</p>
        </div>
      </div>       -->

  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'
import axios from 'axios'
import router from '../router'
import { calculatorUiToCsv, formatDarabarDisplay, blockPageOsszeg, shouldShowBlockTotalRow } from '../utils/munkalapCsvExport'

export default {
  data () {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      token: localStorage.usertoken,
      auth: '',
      userType : decoded.usertype,
      first_name: decoded.first_name,
      last_name: decoded.last_name,
      monogram: decoded.monogram,
      status: [],
      statusSelect: [],
      statusEditId: 0,
      partnerkategoriaSelected: null,
      partnerkategoria: [
        { value: 'A1', text: 'A1' },
        { value: 'VEA', text: 'VEA' },
        { value: 'BID', text: 'BID' },
        { value: 'TD', text: 'TD' },
        { value: 'K5', text: 'K5' },
        { value: 'K6', text: 'K6' },
        { value: 'K7', text: 'K7' },
        { value: 'K8', text: 'K8' },
        { value: 'K9', text: 'K9' },
        { value: 'K10', text: 'K10' }
      ],
      megjegyzes: '',
      anyagTipus: [],
      anyagTipusSelect: [],
      anyagTipusName: null,
      myTempAnyagTipus: [],
      ar: '',
      myTempElements: [
        {
          tipusid: '',
          tipusName: '',
          azonosito: '',
          tetelnev: '',
          db: '',
          cm1: '',
          cm2: '',
          m2: ''
        }
      ],
      myTetels: [],
      osszterulet: null,
      osszfm: null,
      megmunkalasList: [],
      megmunkalasSelect: null,
      azonTemp: '',
      partner: '',
      emaillink: '',
      cikkek: [],
      cikkSelect: [],
      myCikkTetels: [],
      nyomdaiMunkalapPanelShow: false,
      AnyagPanelShow: false,
      EgyebTetelekShow: false,
      VegosszegShow: false,
      MunkalapShow: true,
      AnygaleirasShow: true,
      VegOsszeg: 0,
      VegSumOsszeg: 0,
      NettoOssz: null,
      client: {},
      pageEditorState: '',
      pageIndex: null,
      csvExporting: false,
      myNyomdaiMunkalapTelels: [
        {
        megnevezes: "",
        meret: "",
        terjedelem: "",
        papir: "",
        szin: "",
        koteszet: "",
        opcio: "",
        egyeb: "",
        mennyiseg: "",
        darabar: "",
        osszesen: ""
        }
      ],
    }
  },
  methods: {
    blockPageOsszeg,
    shouldShowBlockTotalRow,
    downloadCsv (filename, csvText) {
      const normalized = String(csvText).replace(/\n/g, '\r\n')
      const blob = new Blob(['\ufeff' + normalized], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    exportCurrentToCsv () {
      if (this.csvExporting) return
      this.csvExporting = true
      try {
        const id = this.$route.params.id || ''
        const status =
          (this.statusSelect && this.statusSelect.megnevezes) ||
          (this.statusSelect && this.statusSelect.text) ||
          (this.statusSelect && this.statusSelect.id) ||
          ''

        const data = {
          id: id,
          partner: this.partner,
          partnerkategoria: this.partnerkategoriaSelected,
          status: status,
          emaillink: this.emaillink,
          megjegyzes: this.megjegyzes,
          szamitottVegOsszeg: this.VegOsszeg,
          VegOsszeg: this.VegSumOsszeg,
          pages: this.myTempAnyagTipus || [],
          cikkTetels: this.myCikkTetels || []
        }

        const csv = calculatorUiToCsv(data)
        const safePartner = (this.partner || 'munkalap').toString().replace(/[\\/:*?"<>|]+/g, '_')
        this.downloadCsv('calculator_' + (id || 'uj') + '_' + safePartner + '.csv', csv)
      } finally {
        this.csvExporting = false
      }
    },
    statusChange: function () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.statusid = this.statusSelect.id
        axios.post('https://'+process.env.ROOT_API+'/anyagtipus/statuschange', { payload })
          .then((res) => {
          }).catch((err) => {
            console.log(err)
          })
      }
    },    
    nyomdaiMunkalapPanel: function () {
      console.log("HI")
      this.nyomdaiMunkalapPanelShow = true

    },
    deleteTetel: function (req, index) {
      this.$delete(req, index)
      this.pageOsszeteruletCount()
      this.pageOsszFmCount()
    },
    deletePage: function (index) {
      // this.myTempAnyagTipus.splice(index, 1)
      this.$delete(this.myTempAnyagTipus,index)
    },
    editMaterial: function (req) {
      // BLOKK SZERKESZTÉSE PAGE EDITORBAN
      this.pageEditorState = 'EDIT'
      this.MunkalapShow = false
      this.myTetels = req.page.tetels
      this.pageOsszeteruletCount()
      this.pageOsszFmCount()
      this.pageIndex = req.page.id
      this.AnyagPanelShow = true
      for (var el in this.anyagTipus) {
        if (req.page.tipusid && this.anyagTipus[el].id == req.page.tipusid) {
          this.anyagTipusSelect = this.anyagTipus[el]
        }
      }
      this.megmunkalasSelect = null
      if (req.page.megmunkalasid) {
        for (var m in this.megmunkalasList) {
          if (this.megmunkalasList[m].id == req.page.megmunkalasid) {
            this.megmunkalasSelect = this.megmunkalasList[m]
          }
        }
      }
    },
    getVegOsszeg1 () {
      let sum = 0
      let sumegyeb = 0
      this.myTempAnyagTipus.forEach(e => {
        sum += (parseInt(e.pageAr) || 0) + (parseInt(e.megmunkalas_ar) || 0)
      })
      this.myCikkTetels.forEach(e => {
        sumegyeb += parseInt(e.db * e.netto)
      })
      let result = this.VegSumOsszeg = sum + sumegyeb
      return result
    },
    calcFm (db, cm1, cm2) {
      return parseFloat((Number(db) * 2 * (Number(cm1) + Number(cm2)) / 100).toFixed(2))
    },
    pageOsszFmCount () {
      this.osszfm = 0
      for (var el in this.myTetels) {
        this.osszfm += parseFloat(this.myTetels[el].fm) || 0
      }
      this.osszfm = parseFloat(this.osszfm.toFixed(2))
    },
    applyDarabarToPage (page) {
      // Megmunkálás blokk: fm-arányos felosztás
      // Anyag blokk: m2-arányos anyagköltség + fm-arányos megmunkálási költség
      const isMegmunkalas = page.blockType === 'megmunkalas' || (page.megmunkalasid && !page.tipusid)
      const osszM2 = Number(page.osszterulet) || 0
      const osszFm = Number(page.osszfm) || 0
      const pageAr = Number(page.pageAr) || 0
      const megmunkalasAr = Number(page.megmunkalas_ar) || 0
      for (const tetel of page.tetels || []) {
        const db = Number(tetel.db) || 0
        if (db === 0) {
          tetel.darabar = 0
          continue
        }
        let resz = 0
        if (isMegmunkalas) {
          if (osszFm > 0) resz = pageAr * ((Number(tetel.fm) || 0) / osszFm)
        } else {
          if (osszM2 > 0) resz = pageAr * ((Number(tetel.m2) || 0) / osszM2)
          if (osszFm > 0) resz += megmunkalasAr * ((Number(tetel.fm) || 0) / osszFm)
        }
        tetel.darabar = Math.round(resz / db)
      }
    },
    onPageArChange (pageElement) {
      this.applyDarabarToPage(pageElement)
      this.getVegOsszeg1()
    },
    onMegmunkalasArChange (pageElement) {
      this.applyDarabarToPage(pageElement)
      this.getVegOsszeg1()
    },
    pageOsszeteruletCount () {
      this.osszterulet = null
      for (var el in this.myTetels) {
        this.osszterulet += parseFloat(this.myTetels[el].m2)
        this.osszterulet.toFixed(2)
      }
    },
    addElement (event) {
      event.preventDefault()
      if (
        this.anyagTipusSelect.length !== 0 &&
        this.myTempElements.megnevezes !== '' &&
        this.myTempElements.db !== '' &&
        this.myTempElements.cm1 !== '' &&
        this.myTempElements.cm2
      ) {
        this.osszterulet = null
        let terulet = this.myTempElements.db * ((this.myTempElements.cm1 * this.myTempElements.cm2) / 100 / 100)
        let fm = this.calcFm(this.myTempElements.db, this.myTempElements.cm1, this.myTempElements.cm2)

        this.myTetels.push(
          {
            tipusid: this.anyagTipusSelect.id,
            azonosito: this.azonTemp,
            tetelnev: this.myTempElements.tetelnev,
            db: this.myTempElements.db,
            cm1: parseFloat(this.myTempElements.cm1, 1).toFixed(1),
            cm2: parseFloat(this.myTempElements.cm2, 1).toFixed(1),
            m2: terulet.toFixed(2),
            fm: fm
          }
        )
        this.pageOsszeteruletCount()
        this.pageOsszFmCount()
        this.myTempElements = []
      }
    },
    addCikkTetel: function () {
      this.myCikkTetels.push(
        {
          cikkid: this.cikkSelect.id,
          megnevezes: this.cikkSelect.megnevezes,
          mennyisegiegyseg: this.cikkSelect.mennyisegiegyseg,
          db: 0,
          netto: this.cikkSelect.netto,
          nettoosszesen: this.cikkSelect.netto
        }
      )
      this.EgyebTetelekShow = true
      this.VegosszegShow = true
      this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow')
    },
    saveWork: function () {
      if (
        this.statusSelect !== '' &&
        this.partner !== '' &&
        this.partnerkategoriaSelected != null
      ) {
        let payload = {}
        payload.id = this.$route.params.id
        payload.azonosito = this.azonTemp
        payload.statusid = this.statusSelect.id
        payload.partnerkategoria = this.partnerkategoriaSelected
        payload.partner = this.partner
        payload.emaillink = this.emaillink
        payload.megjegyzes = this.megjegyzes
        payload.kiallitotta = this.monogram
        payload.cikkTetels = this.myCikkTetels
        payload.pages = this.myTempAnyagTipus
        payload.token = this.token
        payload.userType = this.userType
        this.getVegOsszeg1()
        payload.szamitottVegOsszeg = this.VegOsszeg
        payload.VegOsszeg = this.VegSumOsszeg
        axios.post('https://'+process.env.ROOT_API+'/munkak/save', {payload}).then((res) => {
          console.log(res.data.id)
          this.$router.push({ name: 'Munkalap' , params: { id: res.data.id }})
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    savePage: function (e) {
      let pageTempAr = null
      if (this.osszterulet >= 0 && this.osszterulet <= 0.124) {
        pageTempAr = this.anyagTipusSelect.ar1 * this.osszterulet
      } else if (this.osszterulet >= 0.125 && this.osszterulet <= 0.249) {
        pageTempAr = this.anyagTipusSelect.ar2 * this.osszterulet
      } else if (this.osszterulet >= 0.250 && this.osszterulet <= 0.499) {
        pageTempAr = this.anyagTipusSelect.ar3 * this.osszterulet
      } else if (this.osszterulet >= 0.500 && this.osszterulet <= 0.749) {
        pageTempAr = this.anyagTipusSelect.ar4 * this.osszterulet
      } else if (this.osszterulet >= 0.750 && this.osszterulet <= 0.999) {
        pageTempAr = this.anyagTipusSelect.ar5 * this.osszterulet
      } else if (this.osszterulet >= 1.000 && this.osszterulet <= 2.499) {
        pageTempAr = this.anyagTipusSelect.ar6 * this.osszterulet
      } else if (this.osszterulet >= 2.500 && this.osszterulet <= 4.999) {
        pageTempAr = this.anyagTipusSelect.ar7 * this.osszterulet
      } else if (this.osszterulet >= 5.000 && this.osszterulet <= 9.999) {
        pageTempAr = this.anyagTipusSelect.ar8 * this.osszterulet
      } else if (this.osszterulet >= 10.000 && this.osszterulet <= 19.999) {
        pageTempAr = this.anyagTipusSelect.ar9 * this.osszterulet
      } else if (this.osszterulet >= 20.000) {
        pageTempAr = this.anyagTipusSelect.ar10 * this.osszterulet
      }
      if (pageTempAr <= this.anyagTipusSelect.minimaldij) {pageTempAr = this.anyagTipusSelect.minimaldij}
      pageTempAr = parseFloat(pageTempAr, 0).toFixed(0)

      // Megmunkálás ár: össz fm × Ft/fm (opcionális)
      const hasMegmunkalas = this.megmunkalasSelect && this.megmunkalasSelect.id
      const megmunkalasAr = hasMegmunkalas
        ? Math.round((Number(this.osszfm) || 0) * (Number(this.megmunkalasSelect.ar_fm) || 0))
        : 0

        if(this.pageEditorState == "EDIT"){
        for (var el in this.myTempAnyagTipus) {
          if(this.myTempAnyagTipus[el].id == this.pageIndex) {
            const page = this.myTempAnyagTipus[el]
            page.blockType = 'anyag'
            page.azonosito = this.azonTemp
            page.osszterulet = parseFloat(this.osszterulet, 2).toFixed(2)
            page.osszfm = this.osszfm
            page.megnevezes = this.anyagTipusSelect.megnevezes
            page.pageTempAr = pageTempAr
            page.pageAr = pageTempAr
            page.tipusid = this.anyagTipusSelect.id
            page.tipusName = this.anyagTipusSelect.tipus
            page.megmunkalasid = hasMegmunkalas ? this.megmunkalasSelect.id : null
            page.megmunkalasName = hasMegmunkalas ? this.megmunkalasSelect.megnevezes : ''
            page.megmunkalas_ar = megmunkalasAr
            page.tetels = this.myTetels
            this.applyDarabarToPage(page)
            this.osszterulet = 0
            this.osszfm = 0
            this.myTetels = []
            this.anyagTipusSelect = []
            this.megmunkalasSelect = null
            this.AnyagPanelShow = false
            this.VegosszegShow = true
            this.MunkalapShow = true
            this.getVegOsszeg1()
          }
        }
      } else {
        const page = {
          blockType: 'anyag',
          azonosito: this.azonTemp,
          osszterulet: parseFloat(this.osszterulet, 2).toFixed(2),
          osszfm: this.osszfm,
          megnevezes: this.anyagTipusSelect.megnevezes,
          pageTempAr: pageTempAr,
          pageAr: pageTempAr,
          tipusid: this.anyagTipusSelect.id,
          tipusName: this.anyagTipusSelect.tipus,
          megmunkalasid: hasMegmunkalas ? this.megmunkalasSelect.id : null,
          megmunkalasName: hasMegmunkalas ? this.megmunkalasSelect.megnevezes : '',
          megmunkalas_ar: megmunkalasAr,
          tetels: this.myTetels
        }
        this.applyDarabarToPage(page)
        this.myTempAnyagTipus.push(page)
        this.osszterulet = 0
        this.osszfm = 0
        this.myTetels = []
        this.anyagTipusSelect = []
        this.megmunkalasSelect = null
        this.AnyagPanelShow = false
        this.VegosszegShow = true
        this.MunkalapShow = true
        this.getVegOsszeg1()
      }


    },
    categoryChange: function () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.filter = this.partnerkategoriaSelected
        payload.getHiddenList = true
        axios.post('https://'+process.env.ROOT_API+'/anyagtipus/getlist', { payload })
          .then((res) => {
            this.anyagTipus = res.data
          }).catch((err) => {
            console.log(err)
          })
      }
    },
    mainDataButtonClick: function () {
      if (
        this.statusSelect !== '' &&
        this.partner !== '' &&
        this.partnerkategoriaSelected != null
      ) {
        this.pageEditorState = ''
        this.myTetels = []
        this.osszterulet = 0
        this.osszfm = 0
        this.megmunkalasSelect = null
        this.MunkalapShow = false
        this.AnyagPanelShow = true
      }
    },
    focusInput() {
      this.$refs.MiniCRM.focus();
    }
  },
  computed: {
    visibleMegmunkalasList () {
      return (this.megmunkalasList || []).filter(m => Number(m.hidden) === 1)
    },
    getVegOsszeg: function () {
      let sum = 0
      let sumegyeb = 0
      this.myTempAnyagTipus.forEach(e => {
        sum += (parseInt(e.pageAr) || 0) + (parseInt(e.megmunkalas_ar) || 0)
      })
      this.myCikkTetels.forEach(e => {
        sumegyeb += parseInt(e.db * e.netto)
      })
      let result = this.VegOsszeg = sum + sumegyeb
    }
  },
  // watch: {
  //   anyagTipusSelect: function (val) {
  //     return this.anyagTipusName = val.tipus
  //   }
  // },
  mounted: function () {
    let id = this.$route.params.id
    let payload = {}
    if (!this.token) {
      router.push({ name: 'Login' })
    } else {
      payload.id = id
      payload.token = this.token
      payload.userType = this.userType
      payload.filter = 'K0'
      payload.getHiddenList = true
      if(payload.id) {
        axios.post('https://'+process.env.ROOT_API+'/munkak/pdf', {payload})
          .then(res => {
            this.client = res.data.client
            this.myTempAnyagTipus = res.data.client.pages
            this.emaillink = this.client.emaillink
            this.megjegyzes = this.client.megjegyzes
            this.partner = this.client.partner
            this.partnerkategoriaSelected = this.client.partnerkategoria
            this.myCikkTetels = this.client.cikkTetels
            this.statusSelect = this.client.statusid
            this.VegSumOsszeg = res.data.client.VegOsszeg
            this.monogram = res.data.client.monogram
            if (this.client.cikkTetels.length > 0) {
              this.EgyebTetelekShow = true
            } else { this.EgyebTetelekShow = false }
            this.categoryChange()
          })
          .catch(err => {
            console.log(err)
          })
      }
      axios.post('https://'+process.env.ROOT_API+'/utils/getcode')
        .then((res) => {
          this.azonTemp = res.data
        }).catch((err) => {
          console.log(err)
        })
      this.partnerkategoriaSelected = 'A1'
      this.categoryChange()
      axios.post('https://'+process.env.ROOT_API+'/cikkek/getlist', { payload })
        .then((res) => {
          this.cikkek = res.data
        }).catch((err) => {
          console.log(err)
        })
      axios.post('https://'+process.env.ROOT_API+'/megmunkalasok/getlist', { payload })
        .then((res) => {
          this.megmunkalasList = res.data
        }).catch((err) => {
          console.log(err)
        })
      axios.post('https://'+process.env.ROOT_API+'/status/getlist', { payload })
        .then((res) => {
          for (var el in res.data) {
            this.status.push(
              {
                value: res.data[el],
                text: res.data[el].megnevezes
              })
          }
          this.statusSelect = res.data[0]
        }).catch((err) => {
          console.log(err)
        })
      this.focusInput()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Calculator.vue